

















































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import FormNavigationButtons from '@/components/tickets/tickets-form/common/FormNavigationButtons.vue';
import * as rules from '@/modules/shared/shared/domain/rules';
import { LinkManagementData } from '@/modules/tickets/incidents/link-management/domain/link-management-data';
import AttachmentZone from '@/modules/tickets/incidents/shared/components/AttachementZone.vue';
import { Attachment } from '@/modules/tickets/incidents/shared/domain/attachment';
import AttachmentSelection from '@/modules/tickets/incidents/shared/components/AttachmentSelection.vue';
import { NetworkSecurityInternetIncidentData } from '@/modules/tickets/incidents/network-security-internet/domain/network-security-internet-incident-data';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    name: 'network-security-internet-general-information',
    components: { PhoneField, AttachmentSelection, AttachmentZone, FormNavigationButtons },
})
export default class NetworkSecurityInternetGeneralInformation extends Vue {
    $refs!: {
        form: any;
    };

    private isFormValid: boolean = true;

    private rules: any = rules;

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    @PropSync('valuesOfForm', { required: true })
    formValues!: {
        generalInformation: NetworkSecurityInternetIncidentData;
        categoriesTypings: Typing[];
    };
}
